var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLineFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.148
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6626"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3378",
    d: "M18 7.304a6.508 6.508 0 01-1.933 4.495 28.655 28.655 0 01-7.054 5.222c-.954.4-.828-.251-.778-.477l.126-.778a1.729 1.729 0 00-.025-.8c-.1-.251-.5-.377-.8-.452C3.213 13.932 0 10.919 0 7.304 0 3.288 4.042-.001 8.987-.001S18 3.288 18 7.304",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3379",
    d: "M7.557 4.844v3.918a.172.172 0 01-.176.176h-.627a.172.172 0 01-.176-.176V4.844a.172.172 0 01.176-.176h.627c.076.025.176.1.176.176zm4.167-.151h-.627a.172.172 0 00-.176.176v2.336L9.114 4.768v-.025h-.778a.172.172 0 00-.176.176v3.868a.172.172 0 00.176.176h.629a.172.172 0 00.176-.176V6.451l1.807 2.436c0 .025.025.025.05.05h.728a.172.172 0 00.176-.176V4.844a.215.215 0 00-.178-.151zm-5.873 3.29H4.144V4.868a.172.172 0 00-.176-.176h-.627a.172.172 0 00-.176.176v3.918a.172.172 0 00.176.176h2.51a.172.172 0 00.176-.176v-.628a.211.211 0 00-.176-.175zm9.337-2.315a.172.172 0 00.176-.176v-.624a.172.172 0 00-.176-.176h-2.51a.192.192 0 00-.125.05.151.151 0 00-.025.1V8.76a.172.172 0 00.176.176h2.51a.172.172 0 00.176-.176v-.628a.172.172 0 00-.176-.176h-1.708v-.653h1.707a.172.172 0 00.176-.176v-.628a.172.172 0 00-.176-.176h-1.707v-.655h1.682z",
    fill: "#555"
  }))));
}

export default __webpack_public_path__ + "static/media/line_full.2233d129b1f57bea0d4c7cb586e7e41b.svg";
export { SvgLineFull as ReactComponent };